// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z5BG","colBig":"styles_colBig__AcsNr","colSmall":"styles_colSmall__5bB4M"};